document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('newsletter_form');
  const emailInput = document.getElementById('newsletter_email');
  const checkbox = document.getElementById('newsletter_checkbox');
  const responseDiv = document.getElementById('newsletter_response');
  const submitBtn = document.getElementById('newsletter_submit');

  if (form && emailInput && responseDiv && submitBtn) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      responseDiv.innerHTML = '';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      const data = new FormData();
      data.append('form_type', 'contact');
      data.append('utf8', '✓');
      data.append('contact[email]', emailInput.value);
      data.append('contact[tags]', 'newsletter');
      if (checkbox) data.append('contact[accepts_marketing]', checkbox.checked);

      fetch('/contact', {
        method: 'POST',
        body: data
      })
      .then(res => res.text())
      .then(text => {
        // Shopify trả HTML, check success/error
        if (text.includes('Thank you')) {
          responseDiv.innerHTML = '<div class="newsletter__success">{{ section.settings.success_text }}</div>';
          form.reset();
        } else {
          responseDiv.innerHTML = '<div class="newsletter__error">{{ section.settings.error_text }}</div>';
        }
        submitBtn.disabled = false;
        submitBtn.textContent = '{{ section.settings.button_text }}';
      })
      .catch(err => {
        responseDiv.innerHTML = '<div class="newsletter__error">{{ section.settings.error_text }}</div>';
        submitBtn.disabled = false;
        submitBtn.textContent = '{{ section.settings.button_text }}';
      });
    });
  }
});



var autoPopup = function () {
    if ($("#newsletter-popup").length > 0) {

      const modals = document.querySelectorAll('.modal-component'); 
      let currentZIndex = 10000; 

      modals.forEach(modalElement => {
        const modalId = modalElement.id; 

        if (localStorage.getItem(`modal_${modalId}_closed`) === 'true') {
            return;
        }

          const delay = parseInt(modalElement.getAttribute('data-time'));
          // modalElement.classList.add('show'); 

          setTimeout(() => {
              modalElement.style.zIndex = currentZIndex + 10; 
              currentZIndex += 10;

              const modal = new bootstrap.Modal(modalElement); 
              modal.show(); 

               modalElement.addEventListener('hidden.bs.modal', () => {
                  localStorage.setItem(`modal_${modalId}_closed`, 'true');
              });

              const closeButton = modalElement.querySelector('.btn-hide-popup');
              if (closeButton) {
                  closeButton.addEventListener('click', () => {
                      localStorage.setItem(`modal_${modalId}_closed`, 'true');
                  });
              }

          }, delay);
      });

      
    }
};
autoPopup();

if ($(".tf-popup-product").length > 0) {
  var preview = $(".tf-popup-product").data("preview");
  var tablet = $(".tf-popup-product").data("tablet");
  var mobile = $(".tf-popup-product").data("mobile");
  var spacingLg = $(".tf-popup-product").data("space-lg");
  var spacingMd = $(".tf-popup-product").data("space-md");
  var spacing = $(".tf-popup-product").data("space");
  var perGroup = $(".tf-popup-product").data("pagination") || 4;
  var perGroupMd = $(".tf-popup-product").data("pagination-md") || 3;
  var perGroupLg = $(".tf-popup-product").data("pagination-lg") || 2;
  var swiper = new Swiper(".tf-popup-product", {
      slidesPerView: mobile,
      spaceBetween: spacing,
      observer: true,
      observeParents: true,
      speed: 1000,
      pagination: {
          el: ".sw-pagination-latest",
          clickable: true,
      },
      slidesPerGroup: perGroup,
      navigation: {
          clickable: true,
          nextEl: ".nav-prev-latest",
          prevEl: ".nav-next-latest",
      },
      breakpoints: {
          768: {
              slidesPerView: tablet,
              spaceBetween: spacingMd,
              slidesPerGroup: perGroupMd,
          },
          1200: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
          },
      },
  });
}